import React from 'react';
// eslint-disable-next-line arca/no-default-export
export default function ({
    width = '32',
    height = '38',
    onClick,
    id
}: SvgIconProps) {
    return (
        <svg
            fill="none"
            id={ id }
            width={ width }
            height={ height }
            viewBox="0 0 32 38"
            xmlns="http://www.w3.org/2000/svg"
            onClick={ onClick }
        >
            <path
            // eslint-disable-next-line max-len
                d="M2.7391 21.3477L2.59418 31.4566L15.7825 36.9997L28.6809 31.4566V21.6375"
                stroke="black"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
            // eslint-disable-next-line max-len
                d="M15.7825 19.0288V36.9997"
                stroke="black"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
            // eslint-disable-next-line max-len
                d="M14.5 10L3.89856 14.2463L15.7825 19.0289L27.5216 14.2463L20 10.5"
                stroke="black"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
            // eslint-disable-next-line max-len
                d="M3.7536 14.2461L1 20.6229L13.3187 25.4054L15.7825 19.0287L18.3912 25.4054L31.1447 20.6229L27.6665 14.2461"
                stroke="black"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <g filter="url(#filter0_d)">
                <path
                // eslint-disable-next-line max-len
                    d="M17.5 14.5C21.5 14 23.5 11.5 23.5 7.5C23.5 3.5 20 0.5 17 0.5"
                    stroke="black"
                    strokeWidth="0.2"
                    strokeDasharray="0.4 0.4"
                />
            </g>
            <circle cx="15.5" cy="7.5" r="7.25" fill="white" stroke="black" strokeWidth="0.5" />
            <path
            // eslint-disable-next-line max-len
                d="M12.0254 6H12.4634V3.88623H12.0239L11.4775 4.26562V4.6582L12.0166 4.29199H12.0254V6ZM14.2729 6.04688C14.8091 6.04688 15.1343 5.62061 15.1343 4.93799C15.1343 4.25537 14.8062 3.83789 14.2729 3.83789C13.7397 3.83789 13.4102 4.25684 13.4102 4.93945C13.4102 5.62354 13.7368 6.04688 14.2729 6.04688ZM14.2729 5.69238C14.0122 5.69238 13.8599 5.42432 13.8599 4.93945C13.8599 4.45898 14.0151 4.19238 14.2729 4.19238C14.5322 4.19238 14.6846 4.45752 14.6846 4.93945C14.6846 5.42432 14.5337 5.69238 14.2729 5.69238ZM16.7417 6.04688C17.2778 6.04688 17.603 5.62061 17.603 4.93799C17.603 4.25537 17.2749 3.83789 16.7417 3.83789C16.2085 3.83789 15.8789 4.25684 15.8789 4.93945C15.8789 5.62354 16.2056 6.04688 16.7417 6.04688ZM16.7417 5.69238C16.481 5.69238 16.3286 5.42432 16.3286 4.93945C16.3286 4.45898 16.4839 4.19238 16.7417 4.19238C17.001 4.19238 17.1533 4.45752 17.1533 4.93945C17.1533 5.42432 17.0024 5.69238 16.7417 5.69238ZM18.8896 6H19.3276V3.88623H18.8882L18.3418 4.26562V4.6582L18.8809 4.29199H18.8896V6ZM12.0679 9.04688C12.604 9.04688 12.9292 8.62061 12.9292 7.93799C12.9292 7.25537 12.6011 6.83789 12.0679 6.83789C11.5347 6.83789 11.2051 7.25684 11.2051 7.93945C11.2051 8.62354 11.5317 9.04688 12.0679 9.04688ZM12.0679 8.69238C11.8071 8.69238 11.6548 8.42432 11.6548 7.93945C11.6548 7.45898 11.8101 7.19238 12.0679 7.19238C12.3271 7.19238 12.4795 7.45752 12.4795 7.93945C12.4795 8.42432 12.3286 8.69238 12.0679 8.69238ZM14.2158 9H14.6538V6.88623H14.2144L13.668 7.26562V7.6582L14.207 7.29199H14.2158V9ZM16.4634 9.04688C16.9995 9.04688 17.3247 8.62061 17.3247 7.93799C17.3247 7.25537 16.9966 6.83789 16.4634 6.83789C15.9302 6.83789 15.6006 7.25684 15.6006 7.93945C15.6006 8.62354 15.9272 9.04688 16.4634 9.04688ZM16.4634 8.69238C16.2026 8.69238 16.0503 8.42432 16.0503 7.93945C16.0503 7.45898 16.2056 7.19238 16.4634 7.19238C16.7227 7.19238 16.875 7.45752 16.875 7.93945C16.875 8.42432 16.7241 8.69238 16.4634 8.69238ZM18.9321 9.04688C19.4683 9.04688 19.7935 8.62061 19.7935 7.93799C19.7935 7.25537 19.4653 6.83789 18.9321 6.83789C18.3989 6.83789 18.0693 7.25684 18.0693 7.93945C18.0693 8.62354 18.396 9.04688 18.9321 9.04688ZM18.9321 8.69238C18.6714 8.69238 18.519 8.42432 18.519 7.93945C18.519 7.45898 18.6743 7.19238 18.9321 7.19238C19.1914 7.19238 19.3438 7.45752 19.3438 7.93945C19.3438 8.42432 19.1929 8.69238 18.9321 8.69238ZM12.0254 12H12.4634V9.88623H12.0239L11.4775 10.2656V10.6582L12.0166 10.292H12.0254V12ZM14.2729 12.0469C14.8091 12.0469 15.1343 11.6206 15.1343 10.938C15.1343 10.2554 14.8062 9.83789 14.2729 9.83789C13.7397 9.83789 13.4102 10.2568 13.4102 10.9395C13.4102 11.6235 13.7368 12.0469 14.2729 12.0469ZM14.2729 11.6924C14.0122 11.6924 13.8599 11.4243 13.8599 10.9395C13.8599 10.459 14.0151 10.1924 14.2729 10.1924C14.5322 10.1924 14.6846 10.4575 14.6846 10.9395C14.6846 11.4243 14.5337 11.6924 14.2729 11.6924ZM16.4209 12H16.8589V9.88623H16.4194L15.873 10.2656V10.6582L16.4121 10.292H16.4209V12ZM18.6685 12.0469C19.2046 12.0469 19.5298 11.6206 19.5298 10.938C19.5298 10.2554 19.2017 9.83789 18.6685 9.83789C18.1353 9.83789 17.8057 10.2568 17.8057 10.9395C17.8057 11.6235 18.1323 12.0469 18.6685 12.0469ZM18.6685 11.6924C18.4077 11.6924 18.2554 11.4243 18.2554 10.9395C18.2554 10.459 18.4106 10.1924 18.6685 10.1924C18.9277 10.1924 19.0801 10.4575 19.0801 10.9395C19.0801 11.4243 18.9292 11.6924 18.6685 11.6924Z"
                fill="black"
            />
            <defs>
                <filter id="filter0_d" x="13" y="0.399902" width="14.6" height="22.1992" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dy="4" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
                </filter>
            </defs>
        </svg>
    );
}
